// 数值转换
export default class LongConverter {
  type = 'num';

  toQuery(item) {
    const must = [];
    const mustNot = [];
    const { formData, columnInfo } = item;
    if (columnInfo.type !== this.type) {
      return;
    }
    const columnKey = `${columnInfo.columnKey}.data.value`;
    let queryItem = { range: { [columnKey]: {} } };

    // 代理must和mustNot
    const queryArr = ['exists_not'].includes(formData.rule) ? mustNot : must;

    const index = queryArr.findIndex(mustItem => {
      return Object.prototype.hasOwnProperty.bind(mustItem.range)(columnKey);
    });
    if (index > -1) {
      queryItem = queryArr[index];
    } else {
      queryArr.push(queryItem);
    }

    if (formData.rule === 'term') {
      queryItem.range[columnKey] = {
        gte: formData.num,
        lte: formData.num
      };
    } else if (['exists', 'exists_not'].includes(formData.rule)) {
      queryItem.range = {
        [`${columnInfo.columnKey}.size`]: { gt: 0 }
      };
    } else if (formData.rule === 'range') {
      queryItem.range[columnKey] = {
        gte: formData.numArr[0],
        lte: formData.numArr[1]
      };
    } else {
      queryItem.range[columnKey][formData.rule] = formData.num;
    }
    return { must, must_not: mustNot };
  }
}
